import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const COMMON_USER_NOTIFICATION_DIALOG_COMPONENT = new InjectionToken<ComponentType<any>>(
	'COMMON_USER_NOTIFICATION_DIALOG_COMPONENT',
);
